export default {"src":"/_next/static/media/Slovenia.665e3015.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};